import { createApi, createBaseQuery } from '@adv-frontend/modules-query';
import { apiV1Request } from '#shared/api/requests';
import {
    type OpenApiGetDashboardTrafficResponseSuccess,
    type OpenApiGetDashboardTrafficSearchParams,
} from '#shared/api/schema';

const apiDashboardTraffic = createApi({
    name: 'entities/dashboard/api/traffic',
    baseQuery: createBaseQuery(apiV1Request),
    endpoints: (builder) => {
        return {
            get: builder.query<
                OpenApiGetDashboardTrafficResponseSuccess,
                { params: OpenApiGetDashboardTrafficSearchParams }
            >({
                query: ({ params }) => {
                    return {
                        url: '/dashboard/traffic',
                        params,
                        method: 'GET',
                    };
                },
            }),
        };
    },
});

export const useGetDashboardTraffic = apiDashboardTraffic.useGetQuery;
